const Modes = {
    VISUALNOISE: {color: "yellow", text: "Визуальный шум"},
    AGRESSIVEFIELD: {color: "red", text: "Агрессивное поле"},
    HOMOGENEOUSFIELD: {color: "blue", text: "Гомогенное поле"},
    COMFORTABLEENVIRONMENT: {color: "lime", text: "Комфортная среда"},
    NONE: {color: "gray", text: ""},
}

export {Modes};